/*
 * @Author: Teemo Ding
 * @Date: 2021-12-02 11:44:12
 * @LastEditTime: 2021-12-02 11:45:53
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/CreateNewOrder/tools.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/orderList',
    name: getI18n('general.sider.allOrders'),
  },
  {
    url: '',
    name: getI18n('allOrders.orderlist.pageLayoutProps_addText'),
  },
];
